import React from "react";

export function CloseRedIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clip-path="url(#clip0_1480_27500)">
          <path
            d="M15.8337 5.34297L14.6587 4.16797L10.0003 8.8263L5.34199 4.16797L4.16699 5.34297L8.82533 10.0013L4.16699 14.6596L5.34199 15.8346L10.0003 11.1763L14.6587 15.8346L15.8337 14.6596L11.1753 10.0013L15.8337 5.34297Z"
            fill="#CD0202"
          />
        </g>
        <defs>
          <clipPath id="clip0_1480_27500">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
